export default "__VITE_ASSET__UkCqViBX__"